<app-loading-spinner *ngIf="isLoading" [inline]="1"></app-loading-spinner>
<nav class="subnav">
  <div class="prev">
    <a [routerLink]="['/programme', 'task-list']"
      ><span class="icon-wrap"
        ><fa-icon [icon]="['fas', 'circle-arrow-left']"></fa-icon></span
    ></a>
  </div>
  <h2>Weekly Reports</h2>
  <div class="next">
    <a [routerLink]="['/programme', 'achievements']">
      <span class="icon-wrap"
        ><fa-icon [icon]="['fas', 'circle-arrow-right']"></fa-icon></span
    ></a>
  </div>
  
</nav>

<div class="container container-inner">
  <div class="row">
    <div class="col-12 col-md-12">
      <div class="card mt-3 bg-dark text-white mb-3">
        <img
          src="/assets/img/programme-weekly-report-360x125.jpg"
          class="card-img-top card-img-top-fh img-mobile"
          alt="..."
        />
        <img
          src="/assets/img/programme-weekly-report-930x260.jpg"
          class="card-img-top card-img-top-fh img-desktop"
          alt="..."
        />
        <div class="card-body text-center">
          <h3 class="card-title card-title-lg">Helping you progress</h3>
          <p class="card-text">
            Our weekly reports provide you with feedback on your performance
            through the programme.
          </p>
        </div>
      </div>
    </div>
      <div class="col-12">
        <div class="card bg-light">
          <div class="card-body">
            <ul class="link-list" *ngIf="currentWeekNumber">
              <ng-container
                *ngFor="
                  let e of [].constructor(currentWeekNumber - 1);
                  let index = index
                "
              >
                <li [ngClass]="{unread:reportsRead.indexOf(currentWeekNumber - index - 1) == -1}">
                  <a class="pointer" (click)="onShowReport(currentWeekNumber - index - 1)">
                    <span class="circle-num bg-primary text-dark"><strong>{{
                      currentWeekNumber - index - 1
                    }}</strong></span>
                    <span class="icon-wrap more-link text-dark"
                      ><fa-icon [icon]="['far', 'file-chart-column']"></fa-icon
                    ></span>
                    <span class="link-label"
                      >Week {{ currentWeekNumber - index - 1 }} Report
                      <span class="badge bg-primary text-dark ms-2" *ngIf="reportsRead.indexOf(currentWeekNumber - index - 1) == -1">NEW</span>
                      </span
                    >
                    <span class="icon-wrap more-link duo-primary-dark"
                      ><fa-icon
                        [icon]="['fad', 'circle-chevron-right']"
                      ></fa-icon
                    ></span>
                  </a>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>
      </div>
    </div>
</div>
